export default {
    TABLE_SETTINGS: "Настройка таблицы",
    SELECT_DOCUMENT_OBJECTS: "Выберите типы объектов",
    LOAD: "Загрузить таблицу"
};
